import { render, staticRenderFns } from "./menu-tertiary.vue?vue&type=template&id=b77aaff0&scoped=true&"
import script from "./menu-tertiary.vue?vue&type=script&lang=js&"
export * from "./menu-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77aaff0",
  null
  
)

export default component.exports